<template>
  <div class="custom-28" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <div class="left">
        <div class="left-content">
          <div class="title">问诊订单</div>
          <div class="price"><span>¥{{ data.servicePrice }}</span></div>
          <div class="status"><span>已支付</span></div>    
        </div>
      </div>
      <div class="right">
        <div class="left-img">
          <img src="../../static/IM/eighteen-msg.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    bgColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#333',
    },
  },
  data() {
    return {
      paramData: {}
    }
  },
  created() {}
}
</script>

<style lang="less" scoped>
.custom-28 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;
  
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        div {
          color: #666666;
        }
        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
        .team-doctor {
          margin: 5px 0;
        }
        .price, .status {
          margin-top: 5px;
          span {
            color: #0CB79F;
          }
        }
      }
    }
    .right{
      .left-img {
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>